import { Component, OnInit, ChangeDetectorRef, Input, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';
import { Title, Meta } from '@angular/platform-browser';

import { BirdService } from '../../bird.service';
import { Taxo } from '../../../taxo/taxo';
import { SpeciesService } from '../../../specie/species.service';
import { HotspotService } from '../../../hotspot/hotspot.service';

@Component({
  selector: 'app-sight-map',
  templateUrl: './sight-map.component.html',
  styleUrls: ['./sight-map.component.scss']
})
export class SightMapComponent implements OnInit {

  @Input() sciName = '';
  @Input() idioma = '';
  taxo: Taxo = new Taxo();
  sights = [];
  lat = 0;
  lng = 0;
  zoom = 1;
  audioURI = null;
  species = [];
  loading = {
    taxo: true,
    sights: true,
    species: false,
    place: false,
    booking: false
  };
  placePic = '';
  share = {
    facebook: ''
  };

  constructor(
    private birdService: BirdService,
    private specieService: SpeciesService,
    private chRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private location: Location,
    private hotspotService: HotspotService,
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) document: any) { }

  onBack() {
    this.location.back();
  }

  getSights() {
    this.loading.sights = true;

    this.birdService
      .getHotSpotsGlobal(this.sciName, this.idioma)
      .subscribe((data: any) => {
        
        this.sights = data.response;
        this.loading.sights = false;
        this.lat = data.response[0].lat;
        this.lng = data.response[0].lng;
        this.chRef.detectChanges();
      });
  }

  afterCloseAudioMarkerInfoWidow(pEvent: Event) {
    this.species = [];
    this.placePic = '';
  }

  beforeOpenAudioMarkerInfoWidow(marker: any) {
    this.loading.species = true;
    this.specieService
      .getSpeciesByHotSpot(marker['LOC-ID'], this.idioma)
      .subscribe((data: any) => {
        this.loading.species = false;
        
        this.species = data.response;
        this.chRef.detectChanges();
      });

    this.loading.place = true;
    this.hotspotService
      .getHotSpotImage(marker['LOC-NAME'] + ' ' + marker['COUNTRY-CODE'])
      .subscribe((data: any) => {
        this.loading.place = false;
        
        this.placePic = data.response.url;
        this.chRef.detectChanges();
      });
  }

  getTaxo() {
    this.loading.taxo = true;

    this.birdService
      .getTaxonInfo(this.sciName, this.idioma)
      .subscribe((data: any) => {
        
        this.taxo = data.response[0];
        this.taxo.bandingCodes = data.response[0]['BANDING-CODES'];
        this.taxo.category = data.response[0]['CATEGORY'];
        this.taxo.comName = data.response[0]['COM-NAME'];
        this.taxo.comNameCodes = data.response[0]['COM-NAME-CODE'];
        this.taxo.ebirdSpeciesGroup = data.response[0]['EBIRD-SPECIES-GROUP'];
        this.taxo.family = data.response[0]['FAMILY'];
        this.taxo.id = data.response[0]['ID'];
        this.taxo.idIdioma = data.response[0]['ID_IDIOMA'];
        this.taxo.pic = data.response[0]['PIC'];
        this.taxo.range = data.response[0]['RANGE'];
        this.taxo.sciName = data.response[0]['SCI-NAME'];
        this.taxo.sciNameCodes = data.response[0]['SCI-NAME-CODES'];
        this.taxo.speciesCode = data.response[0]['SPECIES-CODE'];
        this.taxo.taxonId = data.response[0]['TAXON-ID'];
        this.taxo.taxonOrder = data.response[0]['TAXON-ORDER'];

        this.loading.taxo = false;

        this.titleService.setTitle('Avistamientos/Mapa/' + this.taxo.sciName + '/' + this.taxo.comName + '/GlobalBirdWatching.org');

        this.metaService.updateTag({ property: 'og:url', content: document.location.href });
        this.metaService.updateTag({ property: 'og:type', content: 'website' });
        this.metaService.updateTag({ property: 'og:title', content: 'Avistamientos en Mapa de la expecie ' + this.taxo.sciName + ' (' + this.taxo.comName + ') GlobalBirdWatching.org' });
        this.metaService.updateTag({ property: 'og:description', content: 'Mapa de Avistamientos reportados en eBird de la Especie ' + this.sciName + '/' + this.taxo.comName });
        this.metaService.updateTag({ property: 'og:image', content: this.taxo.pic });

        this.share.facebook += '?type=website&title=' + 'Mapa de Avistamientos de la Especie ' + escape(this.taxo.sciName) + ' (' + escape(this.taxo.comName) + ') GlobalBirdWatching.org' + '&description=' + 'Mapa de Avistamientos reportados en eBird de la Especie ' + this.sciName + ' (' + this.taxo.comName + ')' + '&image=' + this.taxo.pic;
      });
  }

  getBackgroundImageStyle(pImageUrl: string) {
    return {
      'background-image': 'url(' + pImageUrl + ')',
      'background-size': 'cover'
    }
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.sciName = params['sciname'];
      this.idioma = params['idioma'];
      this.share.facebook = document.location.href;
      this.getTaxo();
      this.getSights();
    });
  }
}
